import API from '@/API/request';

export const waitingProcessingApi = {
  // 获取城市列表
  getCityList: (params) => API.get(`/lead/option_config/city/${params}`),
  // 获取区域，大区列表
  getRegionArea: (params) => API.get(`/lead/option_config/regin_area/${params}`),
  // 获取某城市下的行业列表
  getIndustryList: (params) => API.get(`/lead/option_config/industry/list`),
  // 获取某城市下的业务单元列表
  getBusinessUnitList: (city, industry) => API.get(`/lead/option_config/business_unit/${city}/${industry}`),
  // 新增线索
  addLead: (params) => API.post('/lead/lead/add', params),
  // 挂起
  hang: (params) => API.post('/lead/lead/hang', params),
  // 已申请创建客户
  customerCreated: (params) => API.post('/lead/lead/customer_created', params),
  // 获取线索无效原因列表
  getReasonList: (params) => API.get(`/lead/option_config/option/list/线索关闭原因/${params}`),
  // 线索关闭
  leadClose: (params) => API.post(`/lead/lead/close`, params),
  // 转移
  transfer: (params) => API.post(`/lead/lead/transfer`, params),
  // 渠道下单
  qdOrder: (params) => API.post(`/lead/lead/qd_order`, params),
  // 转内销
  toInsaler: (params) => API.post(`/lead/lead/to_insaler`, params),
  // 转外销
  toOutsaler: (params) => API.post(`/lead/lead/insaler_to_outsaler`, params),
  // 获取重复线索列表
  getRepeatList: (params) => API.post('/lead/lead/list/double', params),
  // 线索删除
  leadDelete: (params) => API.post('/lead/lead/delete', params),
  // 线索合并
  leadMerge: (params) => API.post('/lead/lead/merge', params),
  // 获取转外销人员下拉列表
  getOutSalerList: (city, industry, param) => API.get(`/lead/option_config/out_saler/?city=${city}&industry=${industry}&param=${param}`),
  // 根据客户编码获取业务机会
  getBusinessChanceList: (params) => API.get(`/lead/crm/opportunity/enable/${params}`),
  // 关联业务机会
  relateBusinessOppo: (params) => API.post('/lead/lead/relate_business_oppo', params),
  // 验证单位名称是否属实
  unitValidator: (params) => API.get(`/lead/tyc/company?companyName=${params}`),
  // 验证单位名称是否属实
  getUnitList: (params) => API.get(`/lead/tyc/search?keyword=${params}`),
  // 获取重复线索列表
  selfFollow: (params) => API.post('/lead/lead/self_follow', params)
};

export const clueSuspend = {
  // 释放
  ralease: (params) => API.post(`/lead/lead/ralease`, params)
};
